module.exports = __webpack_public_path__ + "img/img13.5b39b566.png";